/* eslint-disable jsx-a11y/media-has-caption */
import { Button, Card, CardActions, CardContent, CardHeader, Divider, Grid } from '@mui/material';
import { ArrowLeftOutlined } from '@ant-design/icons';
import React, { useContext, useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import Cookies from 'universal-cookie';
import { Link, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { DashboardPanelContext } from '../../../../components/context/DashboardContext';
import BSubmitButton from '../../../../components/buttons/SubmitButton';
import BTextField from '../../../../components/inputs/forms/BTextField';
import { setValues, onChangeForBComponents, convertArrayToKeyedObject } from '../../../../common/utilities';
import { BSwalShowError } from '../../../../common/BSwal';
import useBasicInformationMountedEffect from '../../../../hooks/useBasicInformationMountedEffect';
import BCheckBoxField from '../../../../components/inputs/forms/BCheckBoxField';
import BSelectField from '../../../../components/inputs/forms/BSelectField';

const initialItem = {
  name: '',
  description: '',
  file: null,
  customer_id: null,
  course_id: null,
  display: true,
};

const cookies = new Cookies();
const url = process.env.REACT_APP_SITE_URL;

const CertificatePage = (props) => {
  const navigate = useNavigate();
  const { staticContext, ...rest } = props;
  const { globalState, fetchItem } = useContext(DashboardPanelContext);

  const { viewReadOnly } = globalState;

  const [loading, setLoading] = useState(false);
  const { errors, handleSubmit, setValue } = useForm();
  const [customers, setCustomers] = useState([]);
  const [courseCustomers, setCourseCustomers] = useState([]);
  const [courses, setCourses] = useState([]);
  const [sliderImage, setSliderImage] = useState(null);

  const {
    id,
    item: currentItem,
    setItem: setCurrentItem,
  } = useBasicInformationMountedEffect({
    match: { params: props.param },
    fetchItemURL: '/certificate-files',
    localStorageKey: 'certificate-files',
    initialItem,
  });

  useEffect(() => {
    fetchItem({
      modelName: `/customers`,
      showLoader: true,
    }).then(async (response) => {
      if (response) {
        const res = [];
        for (let i = 0; i < response.data?.data?.length; i++) {
          if (response.data?.data[i].display === '1') {
            res.push(response.data?.data[i]);
          }
        }
        if (response.data?.last_page > 1) {
          for (let j = 2; j <= response.data?.last_page; j++) {
            // eslint-disable-next-line no-await-in-loop
            await fetchItem({
              modelName: `/customers?page=${j}`,
              showLoader: true,
            }).then((r) => {
              for (let n = 0; n < r.data?.data?.length; n++) {
                if (r.data?.data[n].display === '1') {
                  res.push(r.data?.data[n]);
                }
              }
            });
          }
        }
        setCustomers(res);
      }
    });
    fetchItem({
      modelName: `/courses`,
      showLoader: true,
    }).then(async (response) => {
      if (response) {
        const res = [];
        for (let i = 0; i < response.data?.data?.length; i++) {
          if (response.data?.data[i].display === '1') {
            res.push(response.data?.data[i]);
          }
        }
        if (response.data?.last_page > 1) {
          for (let j = 2; j <= response.data?.last_page; j++) {
            // eslint-disable-next-line no-await-in-loop
            await fetchItem({
              modelName: `/courses?page=${j}`,
              showLoader: true,
            }).then((r) => {
              for (let n = 0; n < r.data?.data?.length; n++) {
                if (r.data?.data[n].display === '1') {
                  res.push(r.data?.data[n]);
                }
              }
            });
          }
        }
        setCourses(res);
      }
    });
  }, []);

  const fileSelectedHandlerLoad = async (e) => {
    setSliderImage(null);
    const name = url.concat(e);
    const imgSrc = `${name}`;
    // eslint-disable-next-line no-shadow
    setSliderImage({ img: imgSrc });
  };

  useEffect(() => {
    if (currentItem.data) {
      setCurrentItem(currentItem.data);
    }
    if (currentItem) {
      setValues(setValue, currentItem);
    }
  }, [currentItem]);

  useEffect(() => {
    if (currentItem?.id && currentItem?.attachments && currentItem?.attachments[0]) {
      fileSelectedHandlerLoad(currentItem.attachments[0].path);
    }
  }, [currentItem.id]);

  const onSubmit = () => {
    setLoading(true);
    const _currentItem = { ...currentItem };
    if (currentItem.display) {
      _currentItem.display = '1';
    } else {
      _currentItem.display = '0';
    }
    delete _currentItem.attachments;
    axios.defaults.baseURL = `${process.env.REACT_APP_BASE_URL}`;
    const formData = new FormData();
    for (let i = 0; i < Object.keys(_currentItem).length; i++) {
      formData.append(Object.keys(_currentItem)[i], Object.values(_currentItem)[i]);
    }
    if (id) {
      formData.append('_method', 'put');
    }
    axios({
      method: 'post',
      url: id ? 'certificate-files/'.concat(id) : 'certificate-files',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${cookies.get('userToken')}`,
      },
    })
      .then((res) => {
        if (res.data.data) {
          navigate('/course-management/certificate-files');
        }
        if (res?.data?.error?.email) {
          BSwalShowError(res?.data?.error?.email);
        }
      })
      .catch((err) => BSwalShowError(err?.data?.messages))
      .finally(() => setLoading(false));
  };

  const onChange = (e) => {
    onChangeForBComponents(e, setValue, currentItem, setCurrentItem);
  };

  const fileSelectedHandler = async (e) => {
    const _currentSlider = currentItem;
    _currentSlider.file = null;
    const file = e.target.files[0];
    // eslint-disable-next-line no-shadow
    _currentSlider.file = file;
    setCurrentItem(_currentSlider);
    setSliderImage(null);
    setSliderImage({ img: e.target.files[0] });
  };

  const getCourseCustomerList = useCallback(
    (courseId) => {
      if (courseId) {
        fetchItem({
          modelName: `/courses/${courseId}/customer-list`,
          showLoader: true,
        }).then(async (response) => {
          if (response) {
            const res = [];
            for (let i = 0; i < response.data?.data?.length; i++) {
              if (response.data?.data[i].display === '1') {
                const user = customers.find((customer) => String(customer.id) === String(response.data?.data[i].id));
                if (user) {
                  res.push(user);
                }
              }
            }
            if (response.data?.last_page > 1) {
              for (let j = 2; j <= response.data?.last_page; j++) {
                // eslint-disable-next-line no-await-in-loop
                await fetchItem({
                  modelName: `/courses/${courseId}/customer-list?page=${j}`,
                  showLoader: true,
                }).then((r) => {
                  for (let n = 0; n < r.data?.data?.length; n++) {
                    if (r.data?.data[n].display === '1') {
                      const user = customers.find((customer) => String(customer.id) === String(r.data?.data[n].id));
                      if (user) {
                        res.push(user);
                      }
                    }
                  }
                });
              }
            }
            setCourseCustomers(res);
          }
        });
      }
    },
    [customers, currentItem.course_id],
  );

  useEffect(() => {
    if (currentItem.course_id) {
      getCourseCustomerList(String(currentItem.course_id));
    }
  }, [currentItem.course_id]);

  return (
    <div style={{ margin: 10 }}>
      {currentItem && (
        <Card {...rest}>
          <Button
            id='backToListIcon'
            component={Link}
            to={{
              pathname: '/course-management/certificate-files',
            }}
            color='secondary'
            variant='outlined'
            style={{ float: 'left', marginTop: '20px', marginLeft: '10px' }}
          >
            <ArrowLeftOutlined />
          </Button>
          <form className='formContainer' onSubmit={handleSubmit(onSubmit)}>
            <CardHeader title='اطلاعات مدرک' />
            <Divider />
            <CardContent>
              <br />
              <Grid container spacing={3}>
                <BTextField
                  xs={12}
                  sm={6}
                  label='نام دانشجو'
                  name='name'
                  value={currentItem?.name}
                  onChange={onChange}
                  readOnly={viewReadOnly}
                  error={errors?.name}
                  required
                />
                <BTextField
                  xs={12}
                  sm={6}
                  label='توضیحات'
                  name='description'
                  value={currentItem?.description}
                  onChange={onChange}
                  readOnly={viewReadOnly}
                  error={errors?.description}
                  required
                />
                <BSelectField
                  sm={6}
                  xs={12}
                  label='انتخاب دوره'
                  name='course_id'
                  value={currentItem?.course_id}
                  onChange={onChange}
                  error={errors?.course_id}
                  items={convertArrayToKeyedObject(courses, 'id', 'description')}
                  readOnly={viewReadOnly}
                  required
                />
                <BSelectField
                  sm={6}
                  xs={12}
                  label='انتخاب دانشجو'
                  name='customer_id'
                  value={currentItem?.customer_id}
                  onChange={onChange}
                  error={errors?.customer_id}
                  items={convertArrayToKeyedObject(courseCustomers, 'id', 'user.name')}
                  readOnly={viewReadOnly || !currentItem?.course_id}
                  required
                />
                <Grid item xs={12} sm={12}>
                  <div style={{ fontSize: '16px' }}>انتخاب فایل</div>
                  <span>اندازه فایل آپلود شده حداکثر 5 مگابایت میباشد. فرمت فایل به صورت pdf میباشد.</span>
                  <br />
                  <input
                    type='file'
                    accept='application/pdf'
                    onChange={fileSelectedHandler}
                    style={{ marginBottom: '15px', marginTop: '15px' }}
                  />
                  {sliderImage?.img?.name && (
                    <div>
                      <p>نام فایل: {sliderImage?.img?.name}</p>
                      <p>فرمت فایل: {sliderImage?.img?.type}</p>
                      <p>سایز فایل: {sliderImage?.img?.size}</p>
                    </div>
                  )}
                  {currentItem?.id && sliderImage?.img && (
                    <div>
                      <a href={sliderImage.img} target='_blank' rel='noreferrer'>
                        نمایش فایل
                      </a>
                    </div>
                  )}
                </Grid>
                <BCheckBoxField
                  sm={12}
                  name='display'
                  label='نمایش داده شود'
                  value={Number(currentItem?.display)}
                  onChange={onChange}
                  readOnly={viewReadOnly}
                />
              </Grid>
            </CardContent>
            <Divider />
            <CardActions>
              <Grid item xs={12} sm={6}>
                {!viewReadOnly && <BSubmitButton id='submitClient' label='ذخیره اطلاعات' loading={loading} />}
              </Grid>
              <Grid item xs={12} sm={6} style={{ display: 'flex', justifyContent: 'flex-end', marginRight: '15px' }}>
                <Button
                  id='backToList'
                  component={Link}
                  to={{
                    pathname: '/course-management/certificate-files',
                  }}
                  color='secondary'
                  variant='outlined'
                >
                  بازگشت به لیست
                </Button>
              </Grid>
            </CardActions>
          </form>
        </Card>
      )}
    </div>
  );
};

export default CertificatePage;
